import CreateTermContainer from "./CreateTermContainer";
export default CreateTermContainer;
